/** Category → Dusk Tools curated pill colors. */
const MAP = {
  macro: { bg: "var(--cat-macro-bg)", fg: "var(--cat-macro-fg)", key: "macro" },
  sports: { bg: "var(--cat-sports-bg)", fg: "var(--cat-sports-fg)", key: "sports" },
  crypto: { bg: "var(--cat-crypto-bg)", fg: "var(--cat-crypto-fg)", key: "crypto" },
  politics: { bg: "var(--cat-politics-bg)", fg: "var(--cat-politics-fg)", key: "politics" },
};

const ON_CHAIN_PALETTE = ["macro", "crypto", "sports", "politics"];

/** Canonical u32 → label. Chain stores ids only; `0` is always allowed. */
export const ON_CHAIN_CATEGORY_NAMES = {
  1: "Macro",
  2: "Crypto",
  3: "Sports",
  4: "Politics",
};

/**
 * @param {string | null | undefined} name
 * @returns {{ bg: string, fg: string, key: string }}
 */
export function categoryStyle(name) {
  const key = String(name ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "");
  return (
    MAP[key] ?? {
      bg: "var(--status-neutral-bg)",
      fg: "var(--status-neutral-fg)",
      key: "neutral",
    }
  );
}

/** Display label for on-chain `Market.category` (u32). `0` = uncategorized. */
export function onChainCategoryLabel(id) {
  if (id == null || id === "") return null;
  const n = Number(id);
  if (!Number.isInteger(n) || n < 0) return null;
  if (n === 0) return "Uncategorized";
  return ON_CHAIN_CATEGORY_NAMES[n] ?? `Cat ${n}`;
}

/**
 * Create-form options: Uncategorized plus owner-enabled ids.
 * @param {number[]} allowedIds from `allowed_categories()`
 * @returns {{ value: string, label: string }[]}
 */
export function createCategoryOptions(allowedIds) {
  const allowed = new Set(
    (allowedIds || []).map(Number).filter((n) => Number.isInteger(n) && n > 0)
  );
  const opts = [{ value: "0", label: "Uncategorized" }];
  for (const n of [...allowed].sort((a, b) => a - b)) {
    opts.push({
      value: String(n),
      label: ON_CHAIN_CATEGORY_NAMES[n] ?? `Category ${n}`,
    });
  }
  return opts;
}

/** Pill colors keyed by on-chain category id (not metadata strings). */
export function onChainCategoryStyle(id) {
  const n = Number(id);
  if (!Number.isInteger(n) || n < 0) {
    return {
      bg: "var(--status-neutral-bg)",
      fg: "var(--status-neutral-fg)",
      key: "neutral",
    };
  }
  if (n === 0) {
    return {
      bg: "var(--status-neutral-bg)",
      fg: "var(--status-neutral-fg)",
      key: "0",
    };
  }
  return categoryStyle(ON_CHAIN_PALETTE[(n - 1) % ON_CHAIN_PALETTE.length]);
}
